import {
    CLOSE_SILENCE_MODAL, EDIT_RULE,
    OPEN_SILENCE_MODAL,
    SHOW_SILENCED_ALERTS,
    SILENCED_RULES,
    SELECT_SILENCE_RULE,
    DESELECT_SILENCE_RULE,
    CLEAR_SELECTED_SILENCE_RULES
} from "../actions/SILENCED_RULES";

const defaultState = {
    rules: [],
    editRule: {
        _id: null,
        project: "",
        host: "",
        alertName: "",
        duration: "",
        comment: "",
        labels: {},
    },
    isOpen: false,
    displaySilencedAlerts: false,
    selectedSilenceRules: []
}

export const silenceRulesReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SILENCED_RULES:
            return { ...state, rules: action.payload }
        case EDIT_RULE:
            return { ...state, editRule: action.payload }
        case OPEN_SILENCE_MODAL:
            return { ...state, isOpen: true }
        case CLOSE_SILENCE_MODAL:
            return { ...state, isOpen: false }
        case SHOW_SILENCED_ALERTS:
            return { ...state, displaySilencedAlerts: action.payload }
        case SELECT_SILENCE_RULE:
            return { ...state, selectedSilenceRules: [...state.selectedSilenceRules, action.payload] }
        case DESELECT_SILENCE_RULE:
            return { ...state, selectedSilenceRules: state.selectedSilenceRules.filter(rule => rule !== action.payload) }
        case CLEAR_SELECTED_SILENCE_RULES:
            return { ...state, selectedSilenceRules: [] }
        default:
            return state
    }
}

export const setSilenceRules = (rules) => ({
    type: SILENCED_RULES,
    payload: rules
})
export const setEditRule = (rule) => ({
    type: EDIT_RULE,
    payload: rule
})
export const setOpenSilenceRules = (openSilenceRules) => ({
    type: OPEN_SILENCE_MODAL,
})
export const setCloseSilenceRules = (closeSilenceRules) => ({
    type: CLOSE_SILENCE_MODAL,
})

export const showSilencedAlerts = (status) => ({
    type: SHOW_SILENCED_ALERTS,
    payload: status
})

export const selectSilenceRule = (rule) => ({
    type: SELECT_SILENCE_RULE,
    payload: rule
})

export const deselectSilenceRule = (ruleId) => ({
    type: DESELECT_SILENCE_RULE,
    payload: ruleId
})

export const clearSelectedSilenceRules = () => ({
    type: CLEAR_SELECTED_SILENCE_RULES
})
